import { render } from "./StatsAndFinanceCard.vue?vue&type=template&id=0fd1b75f"
import script from "./StatsAndFinanceCard.vue?vue&type=script&lang=js"
export * from "./StatsAndFinanceCard.vue?vue&type=script&lang=js"

import "./StatsAndFinanceCard.vue?vue&type=style&index=0&id=0fd1b75f&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__